import React, { useCallback, useEffect, useState } from 'react';
import {
  Modal,
  Box,
  Typography,
  Button,
  Paper,
  Fade,
  IconButton,
  TextField,
  Autocomplete,
  Backdrop,
  CircularProgress,
} from '@mui/material';
import { showErrorSnackbar, showSuccessSnackbar, showWarningSnackbar } from '../snackBar/snakbar';
import { cancelInvoiceMaster, deleteInvoiceMaster } from '../../graphql/mutations';
import { API, graphqlOperation } from 'aws-amplify';
import TeaxtareaField from '../formElements/TeaxtareaField';

import { useNavigate } from 'react-router-dom';
import Checkbox from '@mui/material/Checkbox';
import { Close } from '@mui/icons-material';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  boxShadow: 24,
  outline: 'none',
  minWidth: '500px',
};

const options = [
  { label: 'Duplicate', id: 1 },
  { label: 'Data entry mistake', id: 2 },
  { label: 'Order Cancelled', id: 3 },
  { label: 'Others', id: 4 },
];

const EInvoiceCancel = React.memo(
  ({ open, state, itemData, handleInputChange, handleEINVBlur, setOpen, backdropOpen, setState, cancelEINV }) => {
    const CancelEINV = () => {
      if (state.reason && state.remark) {
        cancelEINV();
      } else {
        handleEINVBlur('reason');
        handleEINVBlur('remark');
        showWarningSnackbar(`Please provide details to cancel ${itemData.from === 'E-Way' ? 'E way bill' : 'E invoice'}`);
      }
    };
    // useEffect(() => {
    //   setState({
    //     reason: "",
    //     remark: "",
    //     errorStatus: {
    //       reason: false,
    //       remark: false,
    //     },
    //   });
    // }, [open]);
    let navigate = useNavigate();
    console.log(state, 'state');

    let handleCancel = () => {
      setOpen(false);
    };
    return (
      <Modal
        open={open}
        onClose={handleCancel}
        aria-labelledby="invoice-cancel-modal-title"
        aria-describedby="invoice-cancel-modal-description"
      >
        <Fade in={open}>
          <Paper sx={style}>
            <Box
              sx={{
                backgroundColor: 'primary.main',
                padding: '5px 15px',
                display: 'flex',
                flexDirection: 'row',
              }}
            >
              <Box sx={{ flex: 1 }}>
                <Typography
                  sx={{
                    color: '#fff',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                  }}
                >
                  Warning
                  <IconButton aria-label="delete" onClick={handleCancel}>
                    <Close sx={{ color: '#fff' }} />
                  </IconButton>
                </Typography>
              </Box>
            </Box>
            <Box sx={{ p: 1 }}>
              <Typography id="invoice-cancel-modal-title" variant="h6" component="h2" sx={{ color: 'red', fontWeight: 'bold' }}>
                Are you sure to cancel
                {itemData.from === 'E-Way' ? ' e way bill' : ' invoice'} ?
              </Typography>

              <Box sx={{ marginTop: '8px' }}>
                {/* <TextField
                name="reason"
                required={true}
                placeholder={`Reason for Cancellation`}
                // placeholder={` ${itemData?.todo == "cancel" ? " Cancellation" : " Deletion"} Reason (optional)`}
                size="small"
                fullWidth 
                // onChange={(e) => {
                //   const value = e.target.value;
                //   if (value.length > 250) {
                //     setState((prev) => ({
                //       ...prev,
                //       reason: value,
                //       errorStatus: {
                //         ...prev?.errorStatus,
                //         reason: true,
                //       },
                //       errorFields: {
                //         ...prev?.errorFields,
                //         reason: `Reason for ${
                //           itemData?.todo == "cancel"
                //             ? " Cancellation"
                //             : " Deletion"
                //         } must be less than 250 characters`,
                //       },
                //     }));
                //   } else if (value.length <= 0) {
                //     setState((prev) => ({
                //       ...prev,
                //       reason: value,
                //       errorStatus: {
                //         ...prev.errorStatus,
                //         reason: true,
                //       },
                //       errorFields: {
                //         ...prev.errorFields,
                //         reason: `Reason for ${
                //           itemData?.todo == "cancel"
                //             ? " Cancellation"
                //             : " Deletion"
                //         } is Required`,
                //       },
                //     }));
                //   } else {
                //     setState((prev) => ({
                //       ...prev,
                //       reason: value,
                //       errorStatus: {
                //         ...prev.errorStatus,
                //         reason: false,
                //       },
                //       errorFields: {
                //         ...prev.errorFields,
                //         reason: "",
                //       },
                //     }));
                //   }
                // }}
              />*/}
                {/* 
                <TextField
                  // error={state.reason === ""}
                  id="reason"
                  name="reason"
                  label="Reason for Cancellation"
                  variant="outlined"
                  size="small"
                  fullWidth
                  value={state.reason}
                  required={true}
                  onBlur={() => handleEINVBlur("reason")}
                  onChange={(e) => handleInputChange("reason", e.target.value)}
                  // rows={6}
                  // onKeyDown={onKeyDown}
                  InputProps={{
                    classes: {
                      input: "custom-scrollbar", // Your custom class
                    },
                  }}
                /> */}
                <Autocomplete
                  id="reason"
                  name="reason"
                  size="small"
                  getOptionLabel={(option) => option.label}
                  value={options?.find((option) => option.id == state.reason) || null}
                  onChange={(event, option) => {
                    handleInputChange('reason', option.id);
                    // setState({ ...state, ["reason"]: option.id });
                    setState((prevState) => {
                      return {
                        ...prevState,
                        ['reason']: option.id,
                        // errorFields: {
                        //     ...prevState.errorFields,
                        //     reason: newReason.length < 5 ? 'Reason is too short' : ''
                        // },
                        errorStatus: {
                          ...prevState.errorStatus,
                        },
                      };
                    });
                  }}
                  options={options}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Reason for Cancellation"
                      sx={{
                        '.MuiFormLabel-asterisk': {
                          color: 'danger.main',
                          fontSize: '20px',
                          fontWeight: 'bold',
                        },
                      }}
                      required={!state.reason}
                      // error={!state.reason}
                    />
                  )}
                />
                <Typography
                  sx={{
                    marginTop: '2px',
                    marginLeft: '10px',
                    marginBottom: '0px',
                    fontSize: '12px',
                    color: 'danger.main',
                  }}
                >
                  {state.errorStatus.reason === true ? 'Required Field' : null}
                </Typography>
              </Box>
              {/* {state.reason === "" ? "ERRor" : null} */}

              <Box sx={{ marginTop: '8px' }}>
                {/* <> */}

                <TextField
                  // error={state.remark === ""}
                  id="remark"
                  name="remark"
                  label={`Remark`}
                  required={true}
                  size="small"
                  fullWidth
                  multiline
                  value={state.remark}
                  rows={6}
                  onBlur={() => handleEINVBlur('remark')}
                  onChange={(e) => handleInputChange('remark', e.target.value)}
                  //   state={state}
                  //   onChange={(e) => {
                  //     const value = e.target.value;
                  //     if (value.length > 250) {
                  //       setState((prev) => ({
                  //         ...prev,
                  //         remark: value,
                  //         errorStatus: {
                  //           ...prev.errorStatus,
                  //           remark: true,
                  //         },
                  //         errorFields: {
                  //           ...prev.errorFields,
                  //           remark: `Remark for Cancellation
                  //              must be less than 250 characters`,
                  //         },
                  //       }));
                  //     } else if (value.length <= 0) {
                  //       setState((prev) => ({
                  //         ...prev,
                  //         remark: value,
                  //         errorStatus: {
                  //           ...prev.errorStatus,
                  //           remark: true,
                  //         },
                  //         errorFields: {
                  //           ...prev.errorFields,
                  //           remark: `Remark for Cancellation is Required`,
                  //         },
                  //       }));
                  //     } else {
                  //       setState((prev) => ({
                  //         ...prev,
                  //         remark: value,
                  //         errorStatus: {
                  //           ...prev.errorStatus,
                  //           remark: false,
                  //         },
                  //         errorFields: {
                  //           ...prev.errorFields,
                  //           remark: "",
                  //         },
                  //       }));
                  //     }
                  //   }}
                />
                {state.errorStatus.remark === true ? (
                  <Typography
                    sx={{
                      marginTop: '2px',
                      marginLeft: '10px',
                      marginBottom: '0px',
                      fontSize: '12px',
                      color: 'danger.main',
                    }}
                  >
                    Required Field
                  </Typography>
                ) : null}
              </Box>

              <Box sx={{ marginTop: '16px', textAlign: 'right' }}>
                <Button variant="outlined" onClick={handleCancel} sx={{ marginRight: '8px' }}>
                  Cancel
                </Button>
                <Button variant="contained" color="error" onClick={CancelEINV}>
                  Confirm
                </Button>
              </Box>
              <Backdrop
                sx={{
                  color: '#fff',
                  zIndex: (theme) => theme.zIndex.drawer + 1,
                }}
                open={backdropOpen}
              >
                <CircularProgress color="inherit" />
              </Backdrop>
            </Box>
          </Paper>
        </Fade>
      </Modal>
    );
  }
);

export default React.memo(EInvoiceCancel);
